// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var dropMenuContainer = "DropDownMenu-module--dropMenuContainer--1eul4";
export var sectionLinkContainer = "DropDownMenu-module--sectionLinkContainer--2YB0H";
export var sectionLinkTitle = "DropDownMenu-module--sectionLinkTitle--16dyj";
export var subEntryContainer = "DropDownMenu-module--subEntryContainer--270WZ";
export var subEntryTitle = "DropDownMenu-module--subEntryTitle--23Ipt";
export var thirdLevelLinksContainer = "DropDownMenu-module--thirdLevelLinksContainer--2rEjM";
export var thirdLevelLink = "DropDownMenu-module--thirdLevelLink--2kwfg";
export var selected = "DropDownMenu-module--selected--25ijx";
export var sectionLink = "DropDownMenu-module--sectionLink--GK8Tf";
export var loginLink = "DropDownMenu-module--loginLink--1cFHb";
export var disabled = "DropDownMenu-module--disabled--3UBgd";
export var innerSectionLink = "DropDownMenu-module--innerSectionLink--23ztK";